const ACTION = {
    UPDATE_USED_PASSWORD: 'UPDATE_USED_PASSWORD:',
    UPDATE_USED_PASSWORD_ERROR_TEXT: 'UPDATE_USED_PASSWORD_ERROR_TEXT',
    UPDATE_USED_PASSWORD_ERROR_TEXT_BY_INDEX: 'UPDATE_USED_PASSWORD_ERROR_TEXT_BY_INDEX'
}

export default ACTION;